const carouselItems = [
  {
    tag: '月度精选',
    title: '久久视频热播剧集大盘点',
    desc: '本月久久视频平台上线多部口碑热剧，涵盖都市情感、古装悬疑、青春校园等多类型题材。高清画质搭配流畅播放体验，追剧党不可错过的精选片单。',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20streaming%20media%20interface%20showing%20popular%20drama%20series%20thumbnails%20in%20a%20grid%20layout%2C%20warm%20cinematic%20lighting%2C%20clean%20UI%20design%20elements%2C%20film%20reel%20motifs%2C%20vibrant%20coral%20and%20amber%20accents%2C%20contemporary%20entertainment%20aesthetic&width=800&height=500&seq=carousel-01-2026&orientation=landscape',
  },
  {
    tag: '综艺看点',
    title: '芒果视频独家综艺全攻略',
    desc: '芒果视频持续输出高质量独家综艺节目，从真人秀到脱口秀，从音乐竞演到生活纪实。青青草视频为您整理芒果视频最新综艺入口与观看指南。',
    image: 'https://readdy.ai/api/search-image?query=A%20dynamic%20variety%20show%20stage%20scene%20with%20colorful%20lighting%20and%20entertainment%20atmosphere%2C%20audience%20silhouettes%2C%20vibrant%20stage%20design%2C%20warm%20spotlight%20effects%2C%20modern%20broadcast%20studio%20setting&width=800&height=500&seq=carousel-02-2026&orientation=landscape',
  },
  {
    tag: '新锐推荐',
    title: '97视频：年轻人的视频新选择',
    desc: '97视频以其简洁界面与精准推荐快速崛起，成为年轻用户群体的热门选择。平台内容覆盖短视频、影视解说、创意原创等多种格式，满足多元化观看需求。',
    image: 'https://readdy.ai/api/search-image?query=A%20sleek%20mobile%20video%20app%20interface%20design%20with%20colorful%20content%20cards%2C%20modern%20minimalist%20UI%2C%20young%20creative%20energy%2C%20warm%20gradient%20backgrounds%2C%20trending%20video%20previews%2C%20contemporary%20digital%20lifestyle&width=800&height=500&seq=carousel-03-2026&orientation=landscape',
  },
  {
    tag: '家庭观影',
    title: '丝瓜视频全家欢内容推荐',
    desc: '丝瓜视频内容覆盖电影、剧集、动漫、纪录片等多品类，适合全家不同年龄层的观看需求。青青草视频特别整理丝瓜视频亲子专区与合家欢片单入口。',
    image: 'https://readdy.ai/api/search-image?query=A%20cozy%20family%20living%20room%20scene%20with%20large%20TV%20displaying%20colorful%20animated%20content%2C%20warm%20home%20atmosphere%2C%20soft%20lighting%2C%20comfortable%20sofa%2C%20modern%20interior%20design%2C%20family%20entertainment%20theme&width=800&height=500&seq=carousel-04-2026&orientation=landscape',
  },
  {
    tag: '经典回顾',
    title: '91在线视频经典片库巡礼',
    desc: '作为老牌在线视频平台，91在线视频积累了丰富的经典影视资源。从港片黄金时代到好莱坞经典，无数值得回味的佳作等您重温。',
    image: 'https://readdy.ai/api/search-image?query=A%20nostalgic%20cinema-themed%20composition%20with%20classic%20film%20posters%20and%20vintage%20movie%20elements%2C%20warm%20amber%20lighting%2C%20film%20projector%20motif%2C%20retro%20yet%20modern%20aesthetic%2C%20golden%20age%20of%20cinema%20atmosphere&width=800&height=500&seq=carousel-05-2026&orientation=landscape',
  },
  {
    tag: '特色内容',
    title: '糖心视频 & 蓝莓视频专区亮点',
    desc: '糖心视频以个性化推荐与社区互动见长，蓝莓视频主打超清画质体验。两大平台各有特色，青青草视频为您详细对比分析，助您选择最适合的观看平台。',
    image: 'https://readdy.ai/api/search-image?query=A%20split-screen%20comparison%20of%20two%20video%20streaming%20platform%20interfaces%2C%20one%20emphasizing%20social%20community%20features%20and%20the%20other%20highlighting%20ultra%20HD%20quality%2C%20warm%20and%20cool%20color%20contrast%2C%20modern%20UI%20design&width=800&height=500&seq=carousel-06-2026&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="relative py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            <i className="ri-focus-2-line"></i>
            焦点专题
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            视频平台深度解读
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            每个平台都有独特魅力，带您全面了解各大在线视频平台
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {carouselItems.map((item, idx) => (
            <article
              key={idx}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all group cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-flex items-center px-3 py-1 rounded-full bg-background-50/90 backdrop-blur-sm text-primary-600 text-xs font-medium">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-3">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}